import { Route } from "@angular/router"
import { ClaimRequestListComponent } from "./ui/claim-request-list/claim-request-list.component";
import { ClaimRequestCreateComponent } from "./ui/claim-request-create/claim-request-create.component";

const claimRequestRoutes: Route[] = [
    {
      path: 'claim-request',
      children: [
        {
          path: '',
          component: ClaimRequestListComponent
        },
        {
          path: 'create',
          component: ClaimRequestCreateComponent
        }
      ]
    }
  ]

export default claimRequestRoutes
